import React from "react";
import { Column } from "@/components/Datatable/types";
import { MyTransactionItem } from "../../api/fetchMyTransactionHistory/types";

// The table cell is left-aligned by DataTable; a block-level span lets the
// amount columns line up on the decimal point without touching the shared
// table. A refund's negative net is muted rather than red: it is a normal
// ledger entry, not an error.
function amountCell(amount: string): React.ReactNode {
  const negative = amount.startsWith("-");
  const formatted = negative ? `-$${amount.slice(1)}` : `$${amount}`;
  return (
    <span
      className={`block text-right${
        negative ? " text-gray-500 dark:text-gray-400" : ""
      }`}
    >
      {formatted}
    </span>
  );
}

/**
 * The member ledger columns. Sortable columns use the backend sort key as
 * their accessorKey; Gross, Discount and Payment Method are display only.
 */
export function myTransactionHistoryColumns(): Column<MyTransactionItem>[] {
  return [
    {
      header: "Date",
      accessorKey: "date",
      enableSorting: true,
      cell: ({ row }) => row.original.date,
    },
    {
      header: "Confirmation #",
      accessorKey: "confirmationNumber",
      enableSorting: true,
      cell: ({ row }) => row.original.confirmationNumber ?? "",
    },
    {
      header: "Event",
      accessorKey: "eventName",
      enableSorting: true,
      cell: ({ row }) => row.original.eventName,
    },
    {
      header: "Session",
      accessorKey: "sessionName",
      enableSorting: true,
      cell: ({ row }) => row.original.sessionName,
    },
    {
      header: "Type",
      accessorKey: "type",
      enableSorting: true,
      cell: ({ row }) => row.original.type,
    },
    {
      header: "Seats",
      accessorKey: "seats",
      cell: ({ row }) => row.original.seats,
    },
    {
      header: "Gross",
      accessorKey: "gross",
      cell: ({ row }) => amountCell(row.original.gross),
    },
    {
      header: "Discount",
      accessorKey: "discount",
      cell: ({ row }) => amountCell(row.original.discount),
    },
    {
      header: "Net",
      accessorKey: "net",
      enableSorting: true,
      cell: ({ row }) => amountCell(row.original.net),
    },
    {
      header: "Payment Method",
      accessorKey: "paymentMethod",
      cell: ({ row }) => row.original.paymentMethod ?? "",
    },
    {
      header: "Status",
      accessorKey: "status",
      enableSorting: true,
      cell: ({ row }) => row.original.status,
    },
  ];
}
